<template>
    <div>
        <!-- Instruções -->
        <div class="modal fade" ref="ciente" id="cienteInstrucoesModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Instruções</h5>
                            <button type="button" class="close" aria-label="Close" @click="fechar_modal()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert mb-1" v-for="(instruc, iix) in instrucoes" :key="iix" :class="instruc.id_instrucao_operadora ? 'alert-info' : 'alert-primary'">
                            <template v-if="instruc.id_instrucao_operadora">
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <strong>{{ instruc.st_titulo }}</strong>
                                        <div style="white-space: pre-wrap;">{{ instruc.st_descricao }}</div>    
                                    </div>
                                    <span class="small text-muted">
                                        I{{ instruc.id_instrucao_operadora }}
                                    </span>
                                </div>
                            </template>

                            <template v-else>
                                <strong>{{ instruc.unidade_procedimento.procedimento.search }}</strong>
                                <div style="white-space: pre-wrap;">{{ instruc.st_instrucao }}</div>
                            </template>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal()" v-if="!nocancel">Cancelar</button>
                        <button type="button" class="btn btn-success" @click="ciente()">Ciente</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';

export default {
    data() {
        return { 
            instrucoes: [], 
        }
    },

    props: ['nocancel'],

    methods: { 
        abrir(instrucoes) {
            this.instrucoes = _.cloneDeep(instrucoes);

            $('#cienteInstrucoesModal').modal('show');
        },

        ciente() { 
            $('#cienteInstrucoesModal').modal('hide');

            this.$emit('ciente');
        },

        fechar_modal() { 
            $('#cienteInstrucoesModal').modal('hide');
        }
    }
}
</script>
